export default __webpack_public_path__ + "static/media/netlify-logo.0acb4696.png";